import { apiClient } from './apiClient';

export interface SearchResult {
  id: number;
  type: 'product' | 'customer' | 'sale';
  title: string;
  subtitle: string;
  data: any;
}

interface SearchResponse {
  success: boolean;
  data: {
    products: any[];
    customers: any[];
    sales: any[];
  };
}

class SearchService {
  async search(query: string): Promise<SearchResult[]> {
    console.log('SearchService: Starting search with query:', query);
    
    if (!query || query.length < 2) {
      console.log('SearchService: Query too short, returning empty results');
      return [];
    }

    try {
      console.log('SearchService: Making API call to /search with query:', query);
      const response = await apiClient.get<SearchResponse>(`/search?q=${encodeURIComponent(query)}`);
      
      console.log('SearchService: API response:', response);
      
      if (response.success && response.data) {
        const results: SearchResult[] = [];

        // Add products to results
        response.data.products.forEach(product => {
          console.log('SearchService: Processing product:', product);
          results.push({
            id: product.id,
            type: 'product',
            title: product.name,
            subtitle: `${product.brand} - ${product.category} | Stock: ${product.stock_quantity}`,
            data: product
          });
        });

        // Add customers to results
        response.data.customers.forEach(customer => {
          console.log('SearchService: Processing customer:', customer);
          results.push({
            id: customer.id,
            type: 'customer',
            title: customer.name,
            subtitle: customer.phone ? `📞 ${customer.phone}` : customer.address || 'No contact info',
            data: customer
          });
        });

        // Add sales to results
        response.data.sales.forEach(sale => {
          console.log('SearchService: Processing sale:', sale);
          results.push({
            id: sale.id,
            type: 'sale',
            title: `Sale #${sale.id}`,
            subtitle: `${sale.customer?.name || 'Walk-in Customer'} - ₨${sale.total_amount} | ${new Date(sale.created_at).toLocaleDateString()}`,
            data: sale
          });
        });

        console.log('SearchService: Final results:', results);
        return results;
      }

      console.log('SearchService: Response not successful or no data');
      return [];
    } catch (error) {
      console.error('SearchService: Search error:', error);
      return [];
    }
  }
}

export const searchService = new SearchService();